<app-loading-screen />
<app-header />
<main class="flex-1">
  <router-outlet />
</main>
<app-footer />
